var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpressLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1800pt",
    height: "1799.999925pt",
    viewBox: "0 0 1200.000000 648.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,648.000000) scale(0.100000,-0.100000)",
    fill: "#8f8f8f",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3240 l0 -3240 6000 0 6000 0 0 3240 0 3240 -6000 0 -6000 0 0 -3240z m5087 1171 c165 -41 309 -127 435 -259 186 -195 289 -444 327 -784 6 -54 11 -124 11 -158 l0 -60 -861 0 -862 0 6 -112 c18 -331 187 -555 484 -640 103 -30 323 -32 423 -5 193 52 358 203 386 353 l6 34 190 0 190 0 -8 -32 c-57 -264 -224 -477 -471 -602 -173 -87 -444 -125 -680 -96 -240 30 -426 116 -584 270 -163 160 -254 342 -312 625 -29 146 -32 465 -5 591 67 309 232 571 456 723 122 83 290 150 427 171 100 15 348 5 442 -19z m1712 -386 c156 -228 287 -415 292 -415 4 0 139 185 300 411 161 226 297 413 303 415 6 2 114 3 239 2 l228 -3 -397 -530 c-218 -291 -403 -540 -411 -552 -14 -21 7 -52 439 -655 250 -348 458 -639 462 -645 6 -10 -46 -13 -246 -13 l-253 1 -329 489 c-180 270 -331 490 -335 490 -4 0 -156 -220 -337 -490 l-329 -489 -237 -1 c-131 0 -238 2 -238 4 0 3 200 285 445 628 245 343 443 628 441 634 -3 7 -187 260 -410 564 -223 304 -406 556 -406 561 0 5 109 9 248 9 l247 0 284 -415z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4700 4100 c-146 -19 -254 -73 -361 -180 -63 -61 -84 -92 -122 -170 -43 -89 -77 -207 -77 -264 l0 -26 655 0 655 0 0 33 c0 59 -38 185 -80 266 -97 187 -273 311 -484 340 -84 12 -104 12 -186 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressLogo);
export default __webpack_public_path__ + "static/media/ExpressLogo.4c48033bce21e05c0013f80970cca42d.svg";
export { ForwardRef as ReactComponent };